import React from 'react';

export const WEIGHT_INPUT_REGEX = /^\d{0,3}[.,]?\d{0,2}$/;

interface WeightInputProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    error?: boolean;
    errorMessage?: string;
    onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export function WeightInput({ value, onChange, label, error, errorMessage, onClick, onFocus }: WeightInputProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;
        if (inputValue === '' || WEIGHT_INPUT_REGEX.test(inputValue)) {
            inputValue = inputValue.replace(',', '.');
            const numValue = parseFloat(inputValue);
            if (inputValue === '' || (numValue >= 0 && numValue <= 100)) {
                onChange(inputValue);
            }
        }
    };

    return (
        <div className="flex flex-col items-end gap-1">
            <div className="flex items-center gap-2">
                {label && <span className="text-sm font-medium text-gray-600">{label}</span>}
                <input
                    type="text"
                    inputMode="decimal"
                    value={value}
                    onChange={handleChange}
                    onClick={onClick}
                    onFocus={onFocus}
                    className={`w-16 rounded border px-2 py-0.5 text-right text-sm font-semibold focus:ring-1 focus:outline-none ${
                        error
                            ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
                            : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
                    }`}
                />
                <span className="text-sm font-semibold">%</span>
            </div>
            {errorMessage && <span className="text-xs text-red-600">{errorMessage}</span>}
        </div>
    );
}
